import {
  BaseVO,
  StreamId,
  streamId,
  StreamKind,
  streamKind
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { MixerId, MixerStreamId } from "../../interface";
import { mixerId, mixerStreamId } from "../../schema";

export class MixerStreamStartedVO extends BaseVO<MixerStreamStarted> {
  private static validation = JsonSchemaValidator.compile(
    MixerStreamStartedVO.validationSchema()
  );

  constructor(value: MixerStreamStarted) {
    super(JsonSchemaValidator.assert(MixerStreamStartedVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["mixerId", "streamId", "data"],
      properties: {
        mixerId,
        streamId,
        data: {
          type: "object",
          required: ["streamId", "kind"],
          properties: {
            streamId: mixerStreamId,
            kind: streamKind
          },
          additionalProperties: false
        }
      },
      additionalProperties: false
    };
  }
}

interface MixerStreamStarted {
  mixerId: MixerId;
  streamId: StreamId;
  data: {
    streamId: MixerStreamId;
    kind: StreamKind;
  };
}
